import { ref } from '@vue/composition-api'
import { timeStampToDate } from '@/utils/date-format'

export default function useNotifications(ctx) {
  const tableColumns = [
    {
      key: 'time',
      label: 'Sent Date',
      formatter: (_, _1, item) => (item.status === 'draft' ? '-' : timeStampToDate(item.time)),
    },
    { key: 'title' },
    { key: 'description' },
    {
      key: 'status',
    },
    {
      key: 'ExpiryDateTime',
      label: 'Expiry Date',
      formatter: (_, _1, item) => (item.status === 'draft' ? '-' : timeStampToDate(item.ExpiryDateTime)),

    },
    (ctx.root.$can('write', 'notifications') && 'actions'),
  ]
  const notifications = ref([])
  const total = ref(0)
  // const page = ref(1)
  const nextID = ref(undefined)
  const loadingNotifications = ref(false)
  const fetchNotifications = async () => {
    try {
      loadingNotifications.value = true
      const filterTemp = {
        limit: 10,
      }
      if (nextID.value) {
        filterTemp.id = nextID.value.id
        filterTemp.status = nextID.value.status
      }
      const res = await ctx.root.$store.dispatch('notifications/fetchNotifications', filterTemp)
      notifications.value = res.records
      total.value = res.total
      nextID.value = res.lastEvaluatedKey
    } catch (error) {
      console.log(error)
    } finally {
      loadingNotifications.value = false
    }
  }
  const editNotification = id => {
    ctx.root.$router.push({ path: '/create-notification', query: { id } })
  }
  const viewNotification = id => {
    ctx.root.$router.push({ path: '/create-notification', query: { id } })
  }
  fetchNotifications()

  const nextHandler = () => {
    fetchNotifications()
  }
  const resetHandler = () => {
    nextID.value = undefined
    fetchNotifications()
  }
  return {
    tableColumns,
    notifications,
    total,
    nextHandler,
    resetHandler,
    // page,
    // perPage,
    loadingNotifications,
    fetchNotifications,
    editNotification,
    viewNotification,
  }
}
